
import { usePeerCommunication } from './usePeerCommunication';
import { sendDirectMessage } from '@/utils/a2a/communication/peerToPeer';
import { messageBus } from '@/utils/a2a/communication/messageBus';

export function useA2APeerCommunication() {
  const {
    peerMessages,
    sendPeerMessage: rawSendPeerMessage,
    findBestPeerAgent,
    setPeerMessages,
    cleanupOldPeerMessages
  } = usePeerCommunication();

  // Peer message using direct message mode
  const sendPeerMessage = (fromAgent, toAgent, content, type) => {
    const message = sendDirectMessage({
      fromAgent,
      toAgent,
      content,
      metadata: {
        communicationType: type,
        priority: type === 'COORDINATION' ? 'high' : 'normal'
      }
    });
    return message;
  };

  // Provide peer message stats and other utils if needed later
  const getPeerMessageStats = () => messageBus.getStats();

  return {
    peerMessages,
    sendPeerMessage,
    findBestPeerAgent,
    setPeerMessages,
    cleanupOldPeerMessages,
    getPeerMessageStats
  };
}
